import JM from 'jalali-moment';
import { TableRow, TableCell, Typography, Button, Stack } from '@mui/material';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

export default function ContentSelectionTableRow({ row, rowNumber, selectContentHandler }) {
  const {
    GameName,
    GameLogo,
    GameSize,
    GameTotalPlay,
    GameVersion,
    GameLastUpdate,
    GameModeLable,
    GameAvrageRate,
    GameCategoryLable,
  } = row;

  return (
    <TableRow hover>
      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <MyAvatar alt={GameName} sx={{ mr: 2 }} src={GameLogo} />

        <Stack>
          <Typography variant="button" noWrap>
            {GameName}
          </Typography>
        </Stack>
      </TableCell>

      <TableCell>
        <Typography variant="button">{GameModeLable}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="button">{GameCategoryLable}</Typography>
      </TableCell>

      <TableCell>{JM(GameLastUpdate).locale('fa').format('YYYY/MM/DD')}</TableCell>

      <TableCell align="right">
        <Button color="warning" variant="contained" onClick={() => selectContentHandler(row)}>
          انتخاب
        </Button>
      </TableCell>
    </TableRow>
  );
}
